import React, { type ComponentType, lazy, Suspense } from 'react';

import Loadable from 'react-loadable';
import { type RouteComponentProps } from 'react-router-dom';

import { fg } from '@atlaskit/platform-feature-flags';

type AgentEmbedProps = { agentId: string };

const AgentEmbedSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_agent-embed-page" */ './main'
		),
);

const LazyAgentEmbedNext = (props: AgentEmbedProps): React.ReactElement => (
	<Suspense fallback={null}>
		<AgentEmbedSuspense {...props} />
	</Suspense>
);

const LazyAgentEmbedLegacy: ComponentType<AgentEmbedProps> & Loadable.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_agent-embed-page" */ './main'
		),
	loading: () => null,
});
LazyAgentEmbedLegacy.displayName = 'lazy(LazyAgentEmbed)';

const LazyAgentEmbed = (props: AgentEmbedProps): React.ReactElement =>
	fg('teams_app_react_19_upgrade') ? (
		<LazyAgentEmbedNext {...props} />
	) : (
		<LazyAgentEmbedLegacy {...props} />
	);

const AgentEmbedRoute = ({
	match,
}: Pick<RouteComponentProps<{ agentId: string }>, 'match'>): React.JSX.Element => {
	return <LazyAgentEmbed agentId={match.params.agentId} />;
};

export default AgentEmbedRoute;
